<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="procedures">
      <p class="sub_title">
        重保工作过程
      </p>
      <div class="content_G">
        <div class="lists_G">
          <div
            v-for="item in processList"
            :key="item.id"
            class="list"
          >
            <div class="item_list">
              <div class="content">
                <div class="content_title">
                  {{ item.title }}
                </div>
                <div class="content_img">
                  <img
                    src="@/assets/securityServices/audit1.png"
                    alt=""
                  >
                </div>
                <div class="content_list">
                  <div
                    v-for="(list, index) in item.list"
                    :key="index"
                  >
                    <div class="list_content">
                      {{ list }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="process_zs">
      <p class="sub_title">
        重保值守流程
      </p>
      <div class="lists">
        <div class="list_top">
          <div class="list_top_title">
            值守前准备
          </div>
          <div class="list_item">
            <div>值守支持申请</div>
            <div>明确值守工作内容和范围</div>
            <div>确认时间、地 点、联系人</div>
          </div>
        </div>
        <span class="icon iconfont icon-jiantou" />
        <div class="list_top">
          <div class="list_top_title">
            现场值守实施
          </div>
          <div class="list_item">
            <div class="list_item_o">
              根据合同内容，完成现场值守工作
            </div>
          </div>
        </div>
        <span class="icon iconfont icon-jiantou" />
        <div class="list_top">
          <div class="list_top_title">
            现场值守报告与汇报
          </div>
          <div class="list_item">
            <div>值守记录整理</div>
            <div>报告输出与提交</div>
            <div>整体汇报</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cost">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in costList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <img
              :src="item.imgUrl"
              alt=""
            >
            <div class="content">
              <p class="p1">
                {{ item.title }}
              </p>
              <p class="p2">
                {{ item.content }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'GuardAgain',
  components: {
    banner
  },
  data() {
    return {
      title: '重保值守服务',
      content:
        '重保值守过程中，帮助客户全面构建重保时期的网络安全积极防御体系，从客户信息系统的需求、设计、开发、上线和运行等各个阶段，加强信息系统生命周期安全管理， 协助客户建立全面的主动安全运营机制，提升客户数据驱动威胁对抗能力。',

      costList: [
        {
          id: 1,
          title: '保障网络运行安全',
          imgUrl: require('@/assets/securityServices/heavyDuty1.png'),
          content: '帮助用户了解安全领域的最新发展，面对威胁能够提前预警。'
        },
        {
          id: 2,
          title: '提高协同配合能力',
          imgUrl: require('@/assets/securityServices/heavyDuty2.png'),
          content: '省心省力，降低安全运维的投入和管理成本。'
        },
        {
          id: 3,
          title: '提高安全防护能力',
          imgUrl: require('@/assets/securityServices/heavyDuty3.png'),
          content: '对漏洞进行排查，防止信息外泄，及时发现问题并修补。'
        }
      ],
      processList: [
        {
          id: 1,
          title: '备战阶段',
          list: ['重保队伍组建', '保障方案设计', '业务资产调研', '远程安全检查']
        },
        {
          id: 2,
          title: '临战阶段',
          list: ['现场安全(可多轮)', '专项安全检查']
        },
        {
          id: 3,
          title: '实战阶段',
          list: ['应急预案与演练', '实战攻防演习']
        },

        {
          id: 4,
          title: '决战阶段',
          list: ['安全监测', '应急值守', '应急处置', '总结与报告']
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
::v-deep .p1 {
  font-size: 24px !important;
}
::v-deep .p2 {
  color: #666666 !important;
  font-size: 20px !important;
  line-height: 40px !important;
}
::v-deep .cost .lists .list .item_list {
  min-height: 400px !important;
  border-radius: 30px;
}
.process_zs {
  width: 100%;
  margin: 108px auto 0;
  padding: 104px 0 131px 0;
  background: #fafbff;

  .lists {
    width: 70%;
    margin: 79px auto 0;
    .icon {
      font-size: 100px;
      color: #75b3f4;
      display: flex;
      justify-content: center;
      margin-top: -20px;
    }
    .list_top {
      border: 5px dashed #568fe8;
      border-radius: 10px;
      margin-top: -20px;

      .list_top_title {
        font-size: 30px;
        font-weight: 400;
        color: #5782e3;
        line-height: 40px;
        margin: 10px;
      }
      .list_item {
        display: flex;
        justify-content: space-around;
        margin-bottom: 39px;
        .list_item_o {
          width: 50%;
          background: #def4f9;
        }
        div {
          width: 25%;
          padding: 44px 2%;
          background: #d7e5fc;
          border-radius: 2px;
          font-size: 36px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          text-align: center;
        }
      }
    }
  }
}
.procedures {
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;

  .content_G {
    width: 70%;
    margin: 0 auto;
    .lists_G {
      width: 100%;
      margin: 95px auto 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .list {
        width: 22%;
        margin: 0 1%;
        border-top: 10px solid #5782e3;

        .item_list {
          width: 100%;
          box-shadow: 1px 1px 10px #dadada;
          min-height: 500px;
          background: #e8effd;

          .content {
            .content_title {
              font-size: 24px;
              font-weight: bold;
              color: #333333;
              line-height: 40px;
              text-align: center;
              padding-top: 60px;
            }
            .content_img {
              margin-top: 25px;
              text-align: center;
              img {
                width: 71px;
                height: 24px;
              }
            }
            .content_list {
              border-radius: 10px;
              display: flex;
              justify-content: center;
              margin-top: 32px;
              .list_content {
                writing-mode: tb-rl;
                padding: 30px 5px;
                background: #fff;
                border-radius: 5px;
                margin: 0 10px;
                font-size: 22px;
                font-weight: 400;
                color: #333333;
                letter-spacing: 8px;
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1200px)and (max-width: 1350px){
  .process_zs .sub_title{
    font-size: 35px;
  }

  .process_zs .lists .list_top .list_item div{
    font-size: 20px;
  }
}

@media (min-width: 1350px)and (max-width: 1500px){
  .process_zs .sub_title{
    font-size: 35px;
  }
  .process_zs .lists .list_top .list_item div{
    font-size: 22px;
  }
}
</style>
